import React from 'react';

const PendingOrder = () => {
	return (
		<div className="body-content">
			<div className="create-order-container p-0 basic-order-section">
				<div className="order-single-accordion">
					<div className="accordion" id="accordionExample">
						<div className="card">
							<div className="card-header" id="headingOne">
								<h2 className="mb-0">
									<button
										className="btn btn-link btn-block d-flex justify-content-between text-left gray_dark_01 regular-14 weight-600 p-0"
										type="button"
										data-toggle="collapse"
										data-target="#collapseOne"
										aria-expanded="true"
										aria-controls="collapseOne"
									>
										<p className="medium-14">Order basic information*</p>
										<div className="arrow-down">
											<img src="/icons/down-arrow-gray-dark-02.svg" alt="arrow" />
										</div>
									</button>
								</h2>
							</div>
							<div
								id="collapseOne"
								className="collapse scroll-x-label"
								aria-labelledby="headingOne"
								data-parent="#accordionExample"
							>
								<div className="card-body  m-0 border-0">
									<div className="create-order-form">
										<div className="row">
											<div className="col-md-4">
												<div className="form-group">
													<label htmlFor="collection">Order title*</label>
													<input
														type="text"
														className="w-100"
														placeholder="Critical POM"
													/>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<div className="select-component">
														<label htmlFor="collection">Project Manager*</label>
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false"
														>
															<p className="regular-14 ">Armhole</p>
															<img src="/images/chevron_down.svg" alt="" />
														</div>
														<div className="dropdown-box dropdown-menu">
															<div className="m-0 search-filter">
																<div className="with-icon right-icon">
																	<input
																		type="text"
																		placeholder="Search"
																		defaultValue
																	/>
																	<span className="right-icon cursor-pointer">
																		<img
																			src="../../public/icons/search.png"
																			alt=""
																		/>
																	</span>
																</div>
															</div>
															<div className="list-items scroll-y-label">
																<div className="single-item">
																	<p>Armhole</p>
																</div>
																<div className="single-item">
																	<p>Item 2</p>
																</div>
																<div className="single-item">
																	<p>Item 3</p>
																</div>
																<div className="single-item">
																	<p>Item 4</p>
																</div>
																<div className="single-item">
																	<p>Item 5</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<div className="select-component">
														<label htmlFor="collection">Account Manager*</label>
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false"
														>
															<p className="regular-14 ">Armhole</p>
															<img src="/images/chevron_down.svg" alt="" />
														</div>
														<div className="dropdown-box dropdown-menu">
															<div className="m-0 search-filter">
																<div className="with-icon right-icon">
																	<input
																		type="text"
																		placeholder="Search"
																		defaultValue
																	/>
																	<span className="right-icon">
																		<img
																			src="../../public/icons/search.png"
																			alt=""
																		/>
																	</span>
																</div>
															</div>
															<div className="list-items scroll-y-label">
																<div className="single-item">
																	<p>Armhole</p>
																</div>
																<div className="single-item">
																	<p>Item 2</p>
																</div>
																<div className="single-item">
																	<p>Item 3</p>
																</div>
																<div className="single-item">
																	<p>Item 4</p>
																</div>
																<div className="single-item">
																	<p>Item 5</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<div className="select-component">
														<label htmlFor="collection">Select buyer*</label>
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false"
														>
															<p className="regular-14 ">Armhole</p>
															<img src="/images/chevron_down.svg" alt="" />
														</div>
														<div className="dropdown-box dropdown-menu">
															<div className="m-0 search-filter">
																<div className="with-icon right-icon">
																	<input
																		type="text"
																		placeholder="Search"
																		defaultValue
																	/>
																	<span className="right-icon">
																		<img
																			src="../../public/icons/search.png"
																			alt=""
																		/>
																	</span>
																</div>
															</div>
															<div className="list-items scroll-y-label">
																<div className="single-item">
																	<p>Armhole</p>
																</div>
																<div className="single-item">
																	<p>Item 2</p>
																</div>
																<div className="single-item">
																	<p>Item 3</p>
																</div>
																<div className="single-item">
																	<p>Item 4</p>
																</div>
																<div className="single-item">
																	<p>Item 5</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<div className="select-component">
														<label htmlFor="collection">Sub-brand</label>
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false"
														>
															<p className="regular-14 ">Armhole</p>
															<img src="/images/chevron_down.svg" alt="" />
														</div>
														<div className="dropdown-box dropdown-menu">
															<div className="m-0 search-filter">
																<div className="with-icon right-icon">
																	<input
																		type="text"
																		placeholder="Search"
																		defaultValue
																	/>
																	<span className="right-icon">
																		<img
																			src="../../public/icons/search.png"
																			alt=""
																		/>
																	</span>
																</div>
															</div>
															<div className="list-items scroll-y-label">
																<div className="single-item">
																	<p>Armhole</p>
																</div>
																<div className="single-item">
																	<p>Item 2</p>
																</div>
																<div className="single-item">
																	<p>Item 3</p>
																</div>
																<div className="single-item">
																	<p>Item 4</p>
																</div>
																<div className="single-item">
																	<p>Item 5</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<div className="select-component">
														<label htmlFor="collection">Revenue stream</label>
														<div
															className="click-box click mb-1"
															data-toggle="dropdown"
															aria-haspopup="true"
															aria-expanded="false"
														>
															<p className="regular-14 ">Armhole</p>
															<img src="/images/chevron_down.svg" alt="" />
														</div>
														<div className="dropdown-box dropdown-menu">
															<div className="m-0 search-filter">
																<div className="with-icon right-icon">
																	<input
																		type="text"
																		placeholder="Search"
																		defaultValue
																	/>
																	<span className="right-icon">
																		<img
																			src="../../public/icons/search.png"
																			alt=""
																		/>
																	</span>
																</div>
															</div>
															<div className="list-items scroll-y-label">
																<div className="single-item">
																	<p>Armhole</p>
																</div>
																<div className="single-item">
																	<p>Item 2</p>
																</div>
																<div className="single-item">
																	<p>Item 3</p>
																</div>
																<div className="single-item">
																	<p>Item 4</p>
																</div>
																<div className="single-item">
																	<p>Item 5</p>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="create-order-form po-upload-and-file">
										<div className="row">
											<div className="col-md-12 pr-2">
												<div className="upload-img mb-2">
													<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
														<div className="d-flex justify-content-start align-items-center">
															<label
																htmlFor="drag-upload"
																className="drag-upload d-flex justify-content-center align-items-center"
															>
																<img
																	src="/icons/upload-blue.svg"
																	width={24}
																/>
																<p className="ml-1">Upload PO</p>
															</label>
															<p className="regular-14 gray_dark_02 pl-4">
																No PO uploaded
															</p>
														</div>
														<input
															type="file"
															id="drag-upload"
															className="file-upload"
															name="image"
															accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
														/>
													</div>
													<div className="all-pdf-files mt-3 d-flex flex-wrap justify-content-start align-items-center">
														<div className="single-pdf-file d-flex align-items-center mr-4">
															<img src="/images/file-pdf.svg" width={24} />
															<p className="regular-14 gray_dark_01 pl-1">
																BMW PO/2021/202..
															</p>
															<div className="acton-img cursor-pointer">
																<img src="/icons/delete_red.svg" width={20} />
															</div>
														</div>
														<div className="single-pdf-file d-flex align-items-center mr-4">
															<img src="/images/file-pdf.svg" width={24} />
															<p className="regular-14 gray_dark_01 pl-1">
																BMW PO/2021/202..
															</p>
															<div className="acton-img cursor-pointer">
																<img src="/icons/delete_red.svg" width={20} />
															</div>
														</div>
														<div className="single-pdf-file d-flex align-items-center mr-4">
															<img src="/images/file-pdf.svg" width={24} />
															<p className="regular-14 gray_dark_01 pl-1">
																BMW PO/2021/202..
															</p>
															<div className="acton-img cursor-pointer">
																<img src="/icons/delete_red.svg" width={20} />
															</div>
														</div>
														<div className="single-pdf-file d-flex align-items-center mr-4">
															<img src="/images/file-pdf.svg" width={24} />
															<p className="regular-14 gray_dark_01 pl-1">
																BMW PO/2021/202..
															</p>
															<div className="acton-img cursor-pointer">
																<img src="/icons/delete_red.svg" width={20} />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="update-button pt-3 text-right">
										<button className="button size32">Update</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="total-style-details mt-20 mb-20">
						<div className="total-style cursor-pointer active">
							<p className="regular-14 gray_dark_02 mb-1">Total no of style</p>
							<p className="semibold-14">1</p>
						</div>
						<div className="pi-sc-info">
							<div className="item cursor-pointer">
								<div className="created">
									<p className="regular-14 gray_dark_02 mb-1">PI created</p>
									<p className="semibold-14">1</p>
								</div>
								<div className="pending">
									<p className="regular-14 gray_dark_02 mb-1">PI pending</p>
									<p className="semibold-14">0</p>
								</div>
							</div>
							<div className="item cursor-pointer">
								<div className="created">
									<p className="regular-14 gray_dark_02 mb-1">SC created</p>
									<p className="semibold-14">0</p>
								</div>
								<div className="pending">
									<p className="regular-14 gray_dark_02 mb-1">SC pending</p>
									<p className="semibold-14">1</p>
								</div>
							</div>
							<div className="item cursor-pointer">
								<div className="created">
									<p className="regular-14 gray_dark_02 mb-1">TNA created</p>
									<p className="semibold-14">0</p>
								</div>
								<div className="pending">
									<p className="regular-14 gray_dark_02 mb-1">TNA pending</p>
									<p className="semibold-14">1</p>
								</div>
							</div>
						</div>
					</div>
					<div className="info-and-button d-flex justify-content-between align-items-center pt-4 pb-4">
						<p className="medium-14 gray_dark_01">
							Designs info{' '}
							<span className="regular-14 gray_dark_02 ml-2">(Total no of style -34)</span>
						</p>
						<button className="button outline size32">
							<img src="/icons/plus-20.svg" alt="" />
							<span className="ml-1">Style</span>
						</button>
					</div>
					{/* //single-order */}
					<div className="order-single-accordion">
						<div className="accordion" id="accordionExample">
							<div className="card">
								<div className="card-header" id="headingTwo">
									<h2 className="mb-0">
										<button
											className="btn btn-link btn-block d-flex justify-content-between text-left gray_dark_01 regular-14 weight-600 p-0"
											type="button"
											data-toggle="collapse"
											data-target="#collapseTwo"
											aria-expanded="true"
											aria-controls="collapseTwo"
										>
											<p className="medium-14">
												DFWWTI-AW2122-AM-0020{' '}
												<span className="regular-12 gray_dark_02">
													(Blue Huddie Half Sleeve)
												</span>
												<img src="/icons/check-bg-green.svg" width={18} alt="" />
											</p>
											<div className="arrow-down">
												<img src="/icons/down-arrow-gray-dark-02.svg" alt="arrow" />
											</div>
										</button>
									</h2>
								</div>
								<div
									id="collapseTwo"
									className="collapse show"
									aria-labelledby="headingTwo"
									data-parent="#accordionExample"
								>
									<div className="card-body border-0 designs-info-section mt-0 radius-6">
										<div className="designs-row order-desing-row">
											<div className="pending-order-stepper on-design-info-item my-12">
												<ul className="d-flex">
													<li className>
														<span className="step-count done">
															<img src="/icons/tick-green.png" alt="" />
														</span>
														PI
													</li>
													<li className>
														<span className="step-count done">
															<img src="/icons/tick-green.png" alt="tich" />
														</span>
														Sales contact
													</li>
													<li className="disabled">
														<span className="step-count done">
															<img src="/icons/tick-green.png" alt="" />
														</span>
														TNA
													</li>
												</ul>
											</div>
											<div className="single-design p-0 m-0 border-0">
												<div className="single-design-card with-editable">
													<div className="card-top">
														<div className="edit-items">
															<div className="select-and-edit d-flex justify-content-between">
																<div className="custom-chekbox">
																	<div className="form-group">
																		<input
																			type="checkbox"
																			id="stage1"
																			name="Company"
																			defaultValue={113}
																		/>
																		<label htmlFor="stage1" />
																	</div>
																</div>
															</div>
														</div>
														<img
															src="/images/t-shirt-orange.png"
															alt="card-image"
														/>
													</div>
												</div>
												<div className="title-and-form-view">
													<div className="d-flex justify-content-between align-items-center">
														<p className="medium-16 gray_dark_01">
															DFWWTI-AW2122-AM-0020{' '}
															<span className="regular-12 gray_dark_02">
																(Blue Huddie Half Sleeve)
															</span>
														</p>
														<div className="edit-and-update-btn  d-flex justify-content-center">
															<button
																type="button"
																className="button text size32 mr-2 px-0"
															>
																Cancel
															</button>
															<button
																type="button"
																className="button text size32 mr-2 px-0"
															>
																<span className="blue">Update</span>
															</button>
															<div className="option">
																<div className="dropdown">
																	<button
																		className="btn btn-default dropdown-toggle"
																		type="button"
																		id="menu1"
																		data-toggle="dropdown"
																		aria-expanded="false"
																	>
																		<img
																			src="/icons/more_vertical.svg"
																			alt=""
																		/>
																	</button>
																	<ul
																		className="dropdown-menu dropdown-menu-right shadow-lg"
																		role="menu"
																		aria-labelledby="menu1"
																		x-placement="bottom-end"
																	>
																		<li
																			role="presentation"
																			className="px-4 pb-3 pt-3"
																		>
																			<a
																				role="menuitem"
																				tabIndex={-1}
																				className="font-weight-normal  text-black"
																				href="/invoices/edit/10052"
																			>
																				Edit
																			</a>
																		</li>
																		<li
																			role="presentation"
																			className="px-4 pb-3 pt-3"
																		>
																			<a
																				role="menuitem"
																				tabIndex={-1}
																				className="font-weight-normal  text-black"
																				href="/invoices/edit/10052"
																			>
																				Add ETD
																			</a>
																		</li>
																		<li
																			role="presentation"
																			className="px-4 pb-3"
																		>
																			<a
																				role="menuitem"
																				tabIndex={-1}
																				className="font-weight-normal  text-black"
																				href
																			>
																				Delete
																			</a>
																		</li>
																	</ul>
																</div>
															</div>
														</div>
													</div>
													<div className="split-order-form split-order-view pt-4">
														{/* 
                                                          <div class="single-design-input">
                                                              <div class="row">
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group mb-2">
                                                                          <label for="design-no">Design No</label>
                                                                          <input type="number" placeholder="MT22-A1280" id="" value="">
                                                                      </div>
                                                                  </div>
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group mb-2">
                                                                          <label for="po-no">PO No</label>
                                                                          <input type="number" id="" placeholder="MT22-A1280" value="">
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                          <div class="single-design-input">
                                                              <div class="row">
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group mb-2">
                                                                          <label for="design-no">PO received date</label>
                                                                          <input type="date" placeholder="02/05/2024" id="" value="">
                                                                      </div>
                                                                  </div>
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group mb-2">
                                                                          <label for="po-no">ETD (dd/mm/yyyy)</label>
                                                                          <input type="date" id="" placeholder="02/05/2024" value="">
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                          <div class="single-design-input">
                                                              <div class="row">
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group mb-2">
                                                                          <label for="design-no">Season</label>
                                                                          <input type="text" placeholder="Summer-23" id="" value="">
                                                                      </div>
                                                                  </div>
                                                                  <div class="col-md-12 p-0">
                                                                      <div class="form-group composition-item mb-0">
                                                                          <label>UOM</label>
                                                                          <div class="d-flex composition-and-qty">
                                                                              <input type="number" min="0.1" max="100"
                                                                                  class="input-percentage" value="">
                                                                              <p class="percentage m-0">Write qty</p>
                                                                              <div class="select-component">
                                                                                  <div class="form-group size36">
                                                                                      <div class="select-component">
                                                                                          <div class="click-box click mb-1" tabindex="0"
                                                                                              data-toggle="dropdown">
                                                                                              <p class="regular-14 ">Composition</p>
                                                                                              <img src="/images/chevron_down.svg" alt="">
                                                                                          </div>
                                                                                          <div data-testid="wrapper">
                                                                                              <div class="dropdown-box  dropdown-menu">
                                                                                                  <div class="m-0 search-filter">
                                                                                                      <div class="with-icon right-icon">
                                                                                                          <input type="text" autocomplete="off"
                                                                                                              placeholder="Composition" value=""><span
                                                                                                              class="right-icon">
                                                                                                              <img
                                                                                                                  src="/icons/search.png"></span>
                                                                                                      </div>
                                                                                                  </div>
                                                                                                  <div class="color-list-box">
                                                                                                      <li class="single-color-item single-item d-flex ">
                                                                                                          <span class="single-item-focus" tabindex="0">Set</span>
                                                                                                      </li>
                                                                                                      <li class="single-color-item single-item d-flex ">
                                                                                                          <span class="single-item-focus" tabindex="0">Piece</span>
                                                                                                      </li>
                                                                                                      <li class="single-color-item single-item d-flex ">
                                                                                                          <span class="single-item-focus" tabindex="0">Pack</span>
                                                                                                      </li>
                                                                                                  </div>
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                                                                  </div>
                                                                              </div>
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                              </div>
                                                          </div>
                                                          */}
														<div className="single-design-input">
															<p className="regular-14 gray_dark_02 mb-12">
																PO NO:{' '}
																<span className="gray_dark_01">
																	{' '}
																	MT22-A1280
																</span>
															</p>
															<p className="regular-14 gray_dark_02">
																PO Received Date:{' '}
																<span className="gray_dark_01">
																	{' '}
																	25-Aug-2021
																</span>
															</p>
														</div>
														<div className="single-design-input">
															<p className="regular-14 gray_dark_02 mb-12">
																ETD:{' '}
																<span className="gray_dark_01">
																	{' '}
																	MT22-A1280
																</span>
															</p>
															<p className="regular-14 gray_dark_02">
																Season:{' '}
																<span className="gray_dark_01">
																	Summer-23
																</span>
															</p>
														</div>
														<div className="single-design-input">
															<p className="regular-14 gray_dark_02 mb-12">
																Total Qty:{' '}
																<span className="gray_dark_01">
																	{' '}
																	MT22-A1280
																</span>
															</p>
															<p className="regular-14 gray_dark_02">
																Price:{' '}
																<span className="gray_dark_01">
																	{' '}
																	25-Aug-2021
																</span>
															</p>
														</div>
														<div className="single-design-input">
															<p className="regular-14 gray_dark_02 mb-12">
																Chart:{' '}
																<span className="gray_dark_01">
																	{' '}
																	MT22-A1280
																</span>
															</p>
															<p className="regular-14 gray_dark_02">
																Supplier:{' '}
																<span className="gray_dark_01">
																	{' '}
																	25-Aug-2021
																</span>
															</p>
														</div>
													</div>
													{/* order-table-veiw */}
													<div class="order-po-details-table mt-20">
														<table class="table order-view-table no-hover border-0 shadow-none ">
															<thead>
																<tr>
																	<th class="regular-14 gray_dark_02 weight-400">
																		PO No
																	</th>
																	<th class="regular-14 gray_dark_02 weight-400">
																		PO Qty
																	</th>
																	<th class="regular-14 gray_dark_02 weight-400">
																		PO value
																	</th>
																	<th class="regular-14 gray_dark_02 weight-400">
																		Buyer ETD
																	</th>
																	<th class="regular-14 gray_dark_02 weight-400">
																		Handover to factory
																	</th>
																	<th class="regular-14 gray_dark_02 weight-400">
																		Factory ETD
																	</th>
																</tr>
															</thead>
															<tbody>
																<tr>
																	<td>January</td>
																	<td>pcs</td>
																	<td>January</td>
																	<td>pcs</td>
																	<td>January</td>
																	<td>pcs</td>
																</tr>
																<tr>
																	<td>January</td>
																	<td>pcs</td>
																	<td>January</td>
																	<td>pcs</td>
																	<td>
																		<span>--</span>
																	</td>
																	<td>
																		<span>--</span>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
											<div className="design-quantity-table w-100">
												<div className="design-info-dropdowns">
													<div className="dropdows-row d-flex justify-content-end mb-1">
														<div className="option">
															<div className="dropdown">
																<button
																	className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
																	type="button"
																	data-toggle="dropdown"
																	aria-expanded="false"
																>
																	Price Sizewise
																	<img
																		src="/icons/down-arrow.png"
																		alt="down"
																	/>
																</button>
																<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
																	<li className="px-4 pb-3 pt-3">
																		<a href className="gray_dark_02">
																			Colorwise
																		</a>
																	</li>
																	<li className="px-4 pb-3 pt-3">
																		<a href className="gray_dark_02">
																			Sizewise
																		</a>
																	</li>
																	<li className="px-4 pb-3">
																		<a href className="gray_dark_02">
																			Size &amp; colorwise
																		</a>
																	</li>
																</ul>
															</div>
														</div>
														<div className="option">
															<div className="dropdown">
																<button
																	className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
																	type="button"
																	data-toggle="dropdown"
																	aria-expanded="false"
																>
																	SKU Sizewise
																	<img
																		src="/icons/down-arrow.png"
																		alt="down"
																	/>
																</button>
																<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
																	<li className="px-4 pb-3 pt-3">
																		<a href className="gray_dark_02">
																			Colorwise
																		</a>
																	</li>
																	<li className="px-4 pb-3 pt-3">
																		<a href className="gray_dark_02">
																			Sizewise
																		</a>
																	</li>
																	<li className="px-4 pb-3">
																		<a href className="gray_dark_02">
																			Size &amp; colorwise
																		</a>
																	</li>
																</ul>
															</div>
														</div>
														<div className="option">
															<div className="dropdown">
																<button
																	className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
																	type="button"
																	data-toggle="dropdown"
																	aria-expanded="false"
																>
																	FOB
																	<img
																		src="/icons/down-arrow.png"
																		alt="down"
																	/>
																</button>
																<ul className="dropdown-menu dropdown-menu-right shadow-4db">
																	<li className="px-4 pb-3 pt-3">
																		<a href className="gray_dark_02">
																			CIF
																		</a>
																	</li>
																</ul>
															</div>
														</div>
													</div>
												</div>
												<div className="design-table d-block ">
													<div className="category-wise-table design-wise-table ">
														<table className="table mt-4">
															<thead>
																<tr>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			SKU NO
																		</p>
																	</th>
																	<th className="color-and-size-column">
																		<p className="cursor-pointer col-heading w-100 d-flex justify-content-center align-items-center">
																			<img
																				src="/icons/Add.svg"
																				alt="add"
																			/>
																		</p>
																		<p className="title regular-10 gray_dark_02">
																			Size
																		</p>
																	</th>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			XS
																		</p>
																		<span className="delete-button radius-4 d-flex justify-content-center align-items-center">
																			<img
																				className
																				src="/icons/delete_red.svg"
																				width={19}
																			/>
																		</span>
																	</th>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			S
																		</p>
																	</th>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			M
																		</p>
																	</th>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			L
																		</p>
																	</th>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			XL
																		</p>
																	</th>
																	<th className="color-and-size-column">
																		<p className="semibold-14 col-heading cursor-pointer d-flex justify-content-center align-items-center">
																			<img
																				src="/icons/plus-20.svg"
																				alt="plus"
																			/>
																		</p>
																		<p className="title regular-10 gray_dark_02">
																			Color
																		</p>
																	</th>
																</tr>
															</thead>
															<tbody>
																<tr>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<th className="color-column">
																		<div className="color-and-content d-flex justify-content-start align-items-center">
																			<div className="arrow cursor-pointer h-100 d-flex justify-content-center align-items-center">
																				<img
																					src="/icons/down-arrow.png"
																					alt=""
																				/>
																			</div>
																			<div className="color-and-name d-flex justify-content-start align-items-center">
																				<span
																					className="color-icon"
																					style={{
																						background:
																							'rgb(131, 255, 131)'
																					}}
																				/>
																				<p className="gray_dark_01 regular-14 pl-2 weight-400">
																					Green
																				</p>
																				<div className="color-action d-flex justify-content-start align-items-center">
																					<span className="cursor-pointer mr-2">
																						<img
																							src="/icons/edit-black-20.svg"
																							alt=""
																						/>
																					</span>
																					<span className="cursor-pointer">
																						<img
																							src="/icons/delete_red.svg"
																							alt=""
																						/>
																					</span>
																				</div>
																			</div>
																		</div>
																	</th>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td className="size-column">
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																</tr>
																{/* another-information */}
																<tr className="another-information">
																	<td className="hide-column">
																		<input type="number" placeholder />
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="Write a information"
																		/>
																	</td>
																	<td>
																		<input type="number" placeholder />
																	</td>
																	<td>
																		<input type="number" placeholder />
																	</td>
																	<td>
																		<input type="number" placeholder />
																	</td>
																	<td>
																		<input type="number" placeholder />
																	</td>
																	<td>
																		<input type="number" placeholder />
																	</td>
																	<td className="hide-column">
																		<input type="number" placeholder />
																	</td>
																</tr>
																<tr>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<th className="color-column">
																		<div className="color-and-content d-flex justify-content-start align-items-center">
																			<div className="arrow cursor-pointer h-100 d-flex justify-content-center align-items-center">
																				<img
																					src="/icons/down-arrow.png"
																					alt=""
																				/>
																			</div>
																			<div className="color-and-name d-flex justify-content-start align-items-center">
																				<span
																					className="color-icon"
																					style={{
																						background:
																							'rgb(131, 255, 131)'
																					}}
																				/>
																				<p className="gray_dark_01 regular-14 pl-2 weight-400">
																					Green
																				</p>
																				<div className="color-action d-flex justify-content-start align-items-center">
																					<span className="cursor-pointer mr-2">
																						<img
																							src="/icons/edit-black-20.svg"
																							alt=""
																						/>
																					</span>
																					<span className="cursor-pointer">
																						<img
																							src="/icons/delete_red.svg"
																							alt=""
																						/>
																					</span>
																				</div>
																			</div>
																		</div>
																	</th>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td className="size-column">
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																</tr>
																<tr>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<th className="color-column">
																		<div className="color-and-content d-flex justify-content-center align-items-center">
																			<p className="text-center">sku</p>
																		</div>
																	</th>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td className="size-column">
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																</tr>
																<tr>
																	<th>
																		<p className="semibold-14 col-heading d-flex justify-content-center align-items-center">
																			Unit price
																		</p>
																	</th>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<input
																			type="number"
																			placeholder="00"
																		/>
																	</td>
																	<td>
																		<div className="totol-price-and-qty d-flex align-items-center justify-content-between">
																			<p className="qty-number medium-14 gray_dark_01">
																				16 QTY
																			</p>
																			<p className="price-number medium-14 gray_dark_01">
																				$32
																			</p>
																		</div>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PendingOrder;
